import React, { Component } from "react";
import Select from "@sm/components/custom/Select";
import TextareaAutosize from 'react-textarea-autosize';
import CustomButton from "@sm/components/custom/Button";

import { formatToLocaleString } from "@sm/utils/utils";
class FormField extends Component {

  render() {
    const { fieldElem, onSaveDataEntries, onValueChange, lockButton, form,  index, dataType } = this.props;

    switch (fieldElem.fieldType) {
    case "select":
      return (
        <Select
          id={ fieldElem.name }
          name={ fieldElem.name }
          value={ form[fieldElem.name] || "" }
          className={ form.errors?.has(fieldElem.name) ? "error-field" : "" }
          required
          clearable={ false }
          disabled={ fieldElem.disabled || (fieldElem.name === 'status' && !form.allowedToChange) }
          onChange={ (value) => onValueChange(value, fieldElem.name, index) }
          options={ fieldElem.getOptions() || [] }
        />
      );

    case "textarea":
      return (
        <TextareaAutosize
          cacheMeasurements
          value={ form[fieldElem.name] || "" }
          onChange={ (value) => onValueChange(value, fieldElem.name, index) }
          className="form-control"
          disabled={ fieldElem.disabled }
        />
      );

    case "checkBox":
      return  fieldElem.empty ? (<span></span>) : (<label className={ `container${fieldElem.big ? " big" : ""}` } style={ { width: fieldElem.big ? "40px" : "20px" } }>
        <input
          type="checkbox"
          checked={ form["isChecked"] }
          disabled={ form["disabled"] }
          onChange={ () => fieldElem.autoMethod(index) }
        />
        <span className= { fieldElem.big ? "big checkmark" : "checkmark" }
          disabled={ form["disabled"] }></span>
      </label>);

    case "button":
      return (
        <CustomButton
          className= { fieldElem.className ? fieldElem.className : "" }
          title={ fieldElem.buttonLabel ? fieldElem.buttonLabel : dataType !== "SETTLEMENT_BY_AMOUNT" ? 'Save' : 'Submit' }
          type="button"
          disabled={ fieldElem.disabled || lockButton || (dataType === "TOP_UP_PAYOUT_WALLET" && form.topUpRecordId !== undefined) }
          onClick={ typeof fieldElem.buttonAction === "function" ? () => fieldElem.buttonAction(dataType) : () => onSaveDataEntries() }
        />
      );

    case "deleteRowButton":
      return (
        fieldElem.empty ? <span /> : (
          <button
            className="delete debit"
            onClick={ () => fieldElem.deleteRow(index) }
          >
            X
          </button>
        ));

    case "addRowButton":
      return (
        fieldElem.empty ? <span /> : (
          <button
            className="add debit"
            onClick={ () => fieldElem.addRow() }
          >
            <span className="plus"> + </span>
          </button>
        ));

    case "empty":
      return (<span/>);

    default:
      return (
        <span style={ { alignItems: "center", display: "inline-flex" } }>
          { fieldElem.disabled &&  typeof fieldElem.onDoubleClick === "function" && (
            <span
              onDoubleClick={ () => fieldElem.onDoubleClick(index, fieldElem.name, fieldElem.label) }
              style={ { position: "absolute", inset: 0, backgroundColor: "transparent" } }
            ></span>
          ) }

          <input
            id={ fieldElem.name }
            name={ fieldElem.name }
            type={ fieldElem.inputType || "text" }
            value={ fieldElem.formatValue ? formatToLocaleString(form[fieldElem.name]) : form[fieldElem.name] }
            className={ `form-control ${ form.errors?.has(fieldElem.name) ? "error-field" : "" }` }
            disabled={ fieldElem.disabled }
            placeholder={ fieldElem.placeholder || "" }
            style={ { paddingLeft: 10, textAlign: fieldElem.rightAlign ? "right" : "" } }
            onChange={ (value) => onValueChange(value, fieldElem.name, index) }
          />
          { form[fieldElem.name + "PostValue"] && form[fieldElem.name + "PostValue"] }
        </span>
      );
    }
  };
}

export default FormField;